export default "__VITE_ASSET__ClY7M6KB__"